import { render } from "./FoldersList.vue?vue&type=template&id=35ca4b40&scoped=true"
import script from "./FoldersList.vue?vue&type=script&lang=js"
export * from "./FoldersList.vue?vue&type=script&lang=js"

import "./FoldersList.vue?vue&type=style&index=0&id=35ca4b40&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ca4b40"]])

export default __exports__